import React, { useState, useEffect } from "react";
import {
  Box,
  Paper,
  Typography,
  Button,
  TextField,
  Select,
  MenuItem,
  IconButton,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  OutlinedInput,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Chip,
  Tooltip,
} from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import EditIcon from "@mui/icons-material/Edit";
import Autocomplete from "@mui/material/Autocomplete";
import Navbar from "../../Navbar";
import Sidebar from "../../Sidebar";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function QuestionManagement() {
  const { API_CONFIG } = require("../../../configuration");
  const [tab, setTab] = useState(0);
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState(false);
  const [newQuestion, setNewQuestion] = useState("");
  const [newQuestionType, setNewQuestionType] = useState("");
  const [newAnswerType, setNewAnswerType] = useState("text");
  const [newDropdownOptions, setNewDropdownOptions] = useState([""]);
  const [questions, setQuestions] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [editQuestion, setEditQuestion] = useState("");
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [assignedQuestions, setAssignedQuestions] = useState([]);
  const [sheets, setSheets] = useState([]);
  const [successDialog, setSuccessDialog] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedSheet, setSelectedSheet] = useState("");
  const [editQuestionType, setEditQuestionType] = useState("");
  const [editAnswerType, setEditAnswerType] = useState("text");
  const [editDropdownOptions, setEditDropdownOptions] = useState([""]);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [selectedQuestions, setSelectedQuestions] = useState([]);

  const fetchQuestions = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await axios.get(`${API_CONFIG.APIURL}/call/questions`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setQuestions(res.data);
    } catch (err) {
      // console.log(err.response?.data || err.message);
    }
  };
  const fetchSheets = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await axios.get(`${API_CONFIG.APIURL}/call/track/sheets`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setSheets(res.data);
    } catch (err) {
      // console.log(err.response?.data || err.message);
    }
  };
  const fetchAssignedQuestions = async (sheetId) => {
    try {
      const token = localStorage.getItem("token");

      const res = await axios.get(
        `${API_CONFIG.APIURL}/call/sheet-questions/${sheetId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      // console.log("Assigned Questions:", res.data);

      // Set selected questions automatically
      const ids = res.data.map((q) => q.id);

      setAssignedQuestions(ids); // store original assigned
      setSelectedQuestions(ids); // display them
    } catch (err) {
      // console.log(err.response?.data || err.message);
    }
  };
  useEffect(() => {
    fetchQuestions();
    fetchSheets();
  }, []);

  // Helpers for managing dynamic dropdown option lists (shared by Add + Edit dialogs)
  const handleOptionChange = (list, setList, index, value) => {
    const updated = [...list];
    updated[index] = value;
    setList(updated);
  };

  const addOption = (list, setList) => {
    setList([...list, ""]);
  };

  const removeOption = (list, setList, index) => {
    setList(list.filter((_, i) => i !== index));
  };

  const handleAddQuestion = async () => {
    try {
      if (!newQuestion.trim()) {
        setSnackbarMessage("Please enter a question");
        setSnackbarOpen(true);
        return;
      }

      if (!newQuestionType) {
        setSnackbarMessage("Please select question type");
        setSnackbarOpen(true);
        return;
      }

      let cleanedOptions = [];
      if (newAnswerType === "dropdown") {
        cleanedOptions = newDropdownOptions
          .map((opt) => opt.trim())
          .filter((opt) => opt.length > 0);

        if (cleanedOptions.length < 2) {
          setSnackbarMessage("Please add at least 2 dropdown options");
          setSnackbarOpen(true);
          return;
        }
      }

      const user = JSON.parse(localStorage.getItem("user") || "{}");

      const payload = {
        question: newQuestion,
        question_type: newQuestionType,
        answer_type: newAnswerType,
        dropdown_options: newAnswerType === "dropdown" ? cleanedOptions : null,
        emp_id: user.emp_id,
      };

      const token = localStorage.getItem("token");

      const response = await axios.post(
        `${API_CONFIG.APIURL}/call/create/question`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.data.success) {
        setSnackbarMessage("Question created successfully");
        setSnackbarOpen(true);

        setNewQuestion("");
        setNewQuestionType("");
        setNewAnswerType("text");
        setNewDropdownOptions([""]);
        setOpenDialog(false);
        await fetchQuestions();
      }
    } catch (error) {
      console.error("Error adding question:", error);

      setSnackbarMessage("Failed to create question");
      setSnackbarOpen(true);
    }
  };

  const updateQuestion = (index, field, value) => {
    const updated = [...questions];
    updated[index][field] = value;
    setQuestions(updated);
  };

  const handleUpdateQuestion = async () => {
    try {
      const token = localStorage.getItem("token");
      const user = JSON.parse(localStorage.getItem("user"));
      const emp_id = user?.emp_id;
      if (!editQuestion.trim()) {
        setSnackbarMessage("Please enter question");
        setSnackbarOpen(true);
        return;
      }

      if (!editQuestionType) {
        setSnackbarMessage("Please select question type");
        setSnackbarOpen(true);
        return;
      }

      let cleanedOptions = [];
      if (editAnswerType === "dropdown") {
        cleanedOptions = editDropdownOptions
          .map((opt) => opt.trim())
          .filter((opt) => opt.length > 0);

        if (cleanedOptions.length < 2) {
          setSnackbarMessage("Please add at least 2 dropdown options");
          setSnackbarOpen(true);
          return;
        }
      }

      await axios.put(
        `${API_CONFIG.APIURL}/call/update/question/${selectedQuestion.id}`,
        {
          question: editQuestion,
          question_type: editQuestionType,
          answer_type: editAnswerType,
          dropdown_options:
            editAnswerType === "dropdown" ? cleanedOptions : null,
          updated_by: emp_id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      await fetchQuestions();

      setSnackbarMessage("Question updated successfully");
      setSnackbarOpen(true);

      setOpenEditDialog(false);
      setSelectedQuestion(null);
    } catch (error) {
      console.error(error);

      setSnackbarMessage("Failed to update question");
      setSnackbarOpen(true);
    }
  };
  const handleEditClick = (question) => {
    setSelectedQuestion(question);
    setEditQuestion(question.question_text);
    setEditQuestionType(question.question_type || "Not Required");
    setEditAnswerType(question.answer_type || "text");
    setEditDropdownOptions(
      question.dropdown_options && question.dropdown_options.length
        ? question.dropdown_options
        : [""],
    );
    setOpenEditDialog(true);
  };

  const deleteQuestion = (index) => {
    const updated = questions.filter((_, i) => i !== index);

    setQuestions(
      updated.map((q, idx) => ({
        ...q,
        id: idx + 1,
      })),
    );
  };

  const handleAssignQuestions = async () => {
    try {
      const token = localStorage.getItem("token");
      const user = JSON.parse(localStorage.getItem("user") || "{}");

      if (!selectedSheet) {
        setSnackbarMessage("Please select a sheet");
        setSnackbarOpen(true);
        return;
      }

      if (selectedQuestions.length === 0) {
        setSnackbarMessage("Please select at least one question");
        setSnackbarOpen(true);
        return;
      }

      const payload = {
        sheet_id: selectedSheet,
        question_ids: selectedQuestions,
        created_by: user.emp_id,
      };

      const response = await axios.post(
        `${API_CONFIG.APIURL}/call/assign-questions`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.data.success) {
        setSnackbarMessage(
          response.data.message || "Questions assigned successfully",
        );
        setSnackbarOpen(true);

        setSelectedQuestions([]);
      }
    } catch (error) {
      console.error(error);

      setSnackbarMessage(
        error.response?.data?.message || "Failed to assign questions",
      );
      setSnackbarOpen(true);
    } finally {
      // Wait 2 seconds, then navigate
      setTimeout(() => {
        setSuccessDialog(false);
        navigate("/DashBoard");
      }, 2000);
    }
  };
  const filteredQuestions = questions.filter((item) =>
    Object.values(item)
      .join(" ")
      .toLowerCase()
      .includes(searchText.toLowerCase()),
  );
  return (
    <>
      <Navbar />
      <Sidebar />
      <Box
        sx={{
          p: { xs: 1.5, sm: 2, md: 3 },
          ml: { xs: 0, md: "250px" },
          width: {
            xs: "100%",
            md: "calc(100% - 250px)",
          },
          boxSizing: "border-box",
          overflowX: "hidden",
          backgroundColor: "#F9FAFB",
          minHeight: "100vh",
        }}
      >
        <Paper sx={{ p: 3 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 3,
            }}
          >
            <Tabs value={tab} onChange={(e, value) => setTab(value)}>
              <Tab label="Create Questions" />
              <Tab label="Assign Questions To Sheet" />
            </Tabs>

            <TextField
              size="small"
              label="Search Questions"
              placeholder="Search..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              sx={{
                width: 350,
                backgroundColor: "#fff",
              }}
            />
          </Box>
          {/* CREATE QUESTIONS */}
          {tab === 0 && (
            <>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb={3}
              >
                <Typography variant="h6">Create Questions</Typography>

                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={() => setOpenDialog(true)}
                >
                  Add Question
                </Button>
              </Box>

              {filteredQuestions.map((item, index) => (
                <Box
                  key={item.id}
                  sx={{
                    border: "1px solid #e0e0e0",
                    borderRadius: 1,
                    p: 2,
                    mb: 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  <DragIndicatorIcon color="action" />

                  <Typography
                    sx={{
                      width: 25,
                      fontWeight: 600,
                    }}
                  >
                    {index + 1}
                  </Typography>

                  <TextField
                    fullWidth
                    variant="standard"
                    value={item.question_text}
                    onChange={(e) =>
                      updateQuestion(index, "question", e.target.value)
                    }
                    InputProps={{
                      disableUnderline: true,
                    }}
                  />

                  <TextField
                    size="small"
                    value={item.question_type}
                    InputProps={{
                      readOnly: true,
                    }}
                    sx={{ minWidth: 150 }}
                  />

                  <IconButton
                    color="primary"
                    onClick={() => handleEditClick(item)}
                  >
                    <EditIcon />
                  </IconButton>

                  <Tooltip
                    title={
                      item.is_assigned
                        ? "Question is already assigned to a sheet"
                        : "Delete Question"
                    }
                  >
                    {/* <span>
                      <IconButton
                        color="error"
                        disabled={item.is_assigned}
                        onClick={() => deleteQuestion(index)}
                      >
                        <DeleteOutlineIcon />
                      </IconButton>
                    </span> */}
                  </Tooltip>
                </Box>
              ))}
            </>
          )}

          {/* ASSIGN QUESTIONS */}
          {tab === 1 && (
            <>
              <Typography variant="h6" mb={3}>
                Assign Questions
              </Typography>

              <Box mb={3}>
                {/* <Typography variant="body2" fontWeight={600} mb={1}>
                  Select Sheet
                </Typography> */}
                <FormControl fullWidth>
                  <InputLabel>Select Sheet</InputLabel>

                  <Select
                    fullWidth
                    size="small"
                    input={<OutlinedInput label="Select Sheet" />}
                    value={selectedSheet}
                    onChange={(e) => {
                      const sheetId = e.target.value;

                      setSelectedSheet(sheetId);

                      // Clear previous sheet's data
                      setAssignedQuestions([]);
                      setSelectedQuestions([]);

                      // Load questions for the newly selected sheet
                      fetchAssignedQuestions(sheetId);
                    }}
                  >
                    {sheets.map((sheet) => (
                      <MenuItem key={sheet.id} value={sheet.id}>
                        {sheet.sheet_name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>

              <Box mb={4}>
                <FormControl fullWidth>
                  {/* <InputLabel>Select Questions</InputLabel> */}

                  <Autocomplete
                    multiple
                    disabled={!selectedSheet} // Disable until sheet is selected
                    options={questions}
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.question_text}
                    value={questions.filter((q) =>
                      selectedQuestions.includes(q.id),
                    )}
                    onChange={(event, newValue) => {
                      const newIds = newValue.map((q) => q.id);

                      const finalIds = [
                        ...assignedQuestions,
                        ...newIds.filter(
                          (id) => !assignedQuestions.includes(id),
                        ),
                      ];

                      setSelectedQuestions([...new Set(finalIds)]);
                    }}
                    getOptionDisabled={(option) =>
                      assignedQuestions.includes(option.id)
                    }
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => {
                        const isAssigned = assignedQuestions.includes(
                          option.id,
                        );

                        return (
                          <Chip
                            {...getTagProps({ index })}
                            key={option.id}
                            label={option.question_text}
                            size="small"
                            onDelete={
                              isAssigned
                                ? undefined
                                : getTagProps({ index }).onDelete
                            }
                          />
                        );
                      })
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Questions"
                        placeholder={
                          selectedSheet
                            ? "Search questions..."
                            : "Please select a sheet first"
                        }
                      />
                    )}
                  />
                </FormControl>
              </Box>

              <Box display="flex" justifyContent="right">
                <Button
                  variant="outlined"
                  sx={{ marginRight: "5px" }}
                  onClick={() => {
                    setSelectedSheet("");
                    setSelectedQuestions([]);
                  }}
                >
                  Cancel
                </Button>

                <Button variant="contained" onClick={handleAssignQuestions}>
                  Assign
                </Button>
              </Box>
            </>
          )}
          <Dialog
            open={openDialog}
            onClose={() => setOpenDialog(false)}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle>Add New Question</DialogTitle>

            <DialogContent>
              <TextField
                fullWidth
                label="Question"
                value={newQuestion}
                onChange={(e) => setNewQuestion(e.target.value)}
                margin="normal"
              />

              <FormControl fullWidth margin="normal">
                <InputLabel>Question Type</InputLabel>

                <Select
                  value={newQuestionType}
                  label="Question Type"
                  onChange={(e) => setNewQuestionType(e.target.value)}
                >
                  <MenuItem value="Required">Required</MenuItem>
                  <MenuItem value="Not Required">Not Required</MenuItem>
                </Select>
              </FormControl>

              <FormControl fullWidth margin="normal">
                <InputLabel>Answer Type</InputLabel>

                <Select
                  value={newAnswerType}
                  label="Answer Type"
                  onChange={(e) => setNewAnswerType(e.target.value)}
                >
                  <MenuItem value="text">Text</MenuItem>
                  <MenuItem value="numeric">Numeric</MenuItem>
                  <MenuItem value="dropdown">Dropdown</MenuItem>
                </Select>
              </FormControl>

              {newAnswerType === "dropdown" && (
                <Box mt={1}>
                  <Typography variant="body2" fontWeight={600} mb={1}>
                    Dropdown Options
                  </Typography>

                  {newDropdownOptions.map((opt, idx) => (
                    <Box
                      key={idx}
                      display="flex"
                      alignItems="center"
                      gap={1}
                      mb={1}
                    >
                      <TextField
                        fullWidth
                        size="small"
                        label={`Option ${idx + 1}`}
                        value={opt}
                        onChange={(e) =>
                          handleOptionChange(
                            newDropdownOptions,
                            setNewDropdownOptions,
                            idx,
                            e.target.value,
                          )
                        }
                      />
                      <IconButton
                        color="error"
                        disabled={newDropdownOptions.length === 1}
                        onClick={() =>
                          removeOption(
                            newDropdownOptions,
                            setNewDropdownOptions,
                            idx,
                          )
                        }
                      >
                        <DeleteOutlineIcon />
                      </IconButton>
                    </Box>
                  ))}

                  <Button
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={() =>
                      addOption(newDropdownOptions, setNewDropdownOptions)
                    }
                  >
                    Add Option
                  </Button>
                </Box>
              )}
            </DialogContent>

            <DialogActions>
              <Button onClick={() => setOpenDialog(false)}>Cancel</Button>

              <Button variant="contained" onClick={handleAddQuestion}>
                Submit
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={openEditDialog}
            onClose={() => setOpenEditDialog(false)}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle>Edit Question</DialogTitle>

            <DialogContent>
              <TextField
                fullWidth
                label="Question"
                value={editQuestion}
                onChange={(e) => setEditQuestion(e.target.value)}
                margin="normal"
              />
              <FormControl fullWidth margin="normal">
                <InputLabel>Question Type</InputLabel>

                <Select
                  value={editQuestionType}
                  label="Question Type"
                  onChange={(e) => setEditQuestionType(e.target.value)}
                >
                  <MenuItem value="Required">Required</MenuItem>
                  <MenuItem value="Not Required">Not Required</MenuItem>
                </Select>
              </FormControl>

              <FormControl fullWidth margin="normal">
                <InputLabel>Answer Type</InputLabel>

                <Select
                  value={editAnswerType}
                  label="Answer Type"
                  onChange={(e) => setEditAnswerType(e.target.value)}
                >
                  <MenuItem value="text">Text</MenuItem>
                  <MenuItem value="numeric">Numeric</MenuItem>
                  <MenuItem value="dropdown">Dropdown</MenuItem>
                </Select>
              </FormControl>

              {editAnswerType === "dropdown" && (
                <Box mt={1}>
                  <Typography variant="body2" fontWeight={600} mb={1}>
                    Dropdown Options
                  </Typography>

                  {editDropdownOptions.map((opt, idx) => (
                    <Box
                      key={idx}
                      display="flex"
                      alignItems="center"
                      gap={1}
                      mb={1}
                    >
                      <TextField
                        fullWidth
                        size="small"
                        label={`Option ${idx + 1}`}
                        value={opt}
                        onChange={(e) =>
                          handleOptionChange(
                            editDropdownOptions,
                            setEditDropdownOptions,
                            idx,
                            e.target.value,
                          )
                        }
                      />
                      <IconButton
                        color="error"
                        disabled={editDropdownOptions.length === 1}
                        onClick={() =>
                          removeOption(
                            editDropdownOptions,
                            setEditDropdownOptions,
                            idx,
                          )
                        }
                      >
                        <DeleteOutlineIcon />
                      </IconButton>
                    </Box>
                  ))}

                  <Button
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={() =>
                      addOption(editDropdownOptions, setEditDropdownOptions)
                    }
                  >
                    Add Option
                  </Button>
                </Box>
              )}
            </DialogContent>

            <DialogActions>
              <Button onClick={() => setOpenEditDialog(false)}>Cancel</Button>

              <Button variant="contained" onClick={handleUpdateQuestion}>
                Update
              </Button>
            </DialogActions>
          </Dialog>
        </Paper>
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={3000}
          onClose={() => setSnackbarOpen(false)}
        >
          <Alert severity="success" onClose={() => setSnackbarOpen(false)}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Box>
    </>
  );
}